import {
  ActionButton,
  Flex,
  Grid,
  Heading,
  View,
  ViewProps,
} from "@adobe/react-spectrum";
import { FC, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectQuestions } from "store/slices/questions";

export const Quiz: FC<ViewProps<6>> = (props) => {
  const questions = useSelector(selectQuestions);
  const [idx, setIdx] = useState(0);
  const [showAnswer, setShowAnswer] = useState(false);

  useEffect(() => {
    setShowAnswer(false);
  }, [questions]);

  const goForward = useCallback(() => {
    setIdx((idx + 1) % questions.length);
    setShowAnswer(false);
  }, [questions, idx]);

  const goBack = useCallback(() => {
    if (idx <= 0) {
      setIdx(questions.length - 1);
    } else {
      setIdx(idx - 1);
    }
    setShowAnswer(false);
  }, [questions, idx]);

  if (!questions.length) return <></>;

  return (
    <>
      <Flex gridArea="back" direction="row" justifyContent="space-around">
        <Flex direction="column" justifyContent="space-around">
          <ActionButton onPress={goBack}>{"<"}</ActionButton>
        </Flex>
      </Flex>

      <View {...props}>
        <Grid
          areas={["question", "answer", "buttons"]}
          rows={["1fr", "1fr", "auto"]}
          height="100%"
          gap="size-600"
        >
          <Flex direction="column" gridArea="question">
            <Heading level={3}>Question:</Heading>
            <Heading level={1}>{questions[idx].question}</Heading>
          </Flex>

          {showAnswer && (
            <Flex direction="column" gridArea="answer">
              <Heading level={3}>Answer:</Heading>
              <Heading level={1}>{questions[idx].answer}</Heading>
            </Flex>
          )}

          <Flex
            gridArea="buttons"
            direction="row"
            justifyContent="space-around"
          >
            {!showAnswer && (
              <ActionButton onPress={() => setShowAnswer(true)}>
                Show answer
              </ActionButton>
            )}
            {showAnswer && (
              <ActionButton onPress={goForward}>Next Question</ActionButton>
            )}
          </Flex>
        </Grid>
      </View>

      <Flex gridArea="forward" direction="row" justifyContent="space-around">
        <Flex direction="column" justifyContent="space-around">
          <ActionButton onPress={goForward}>{">"}</ActionButton>
        </Flex>
      </Flex>
    </>
  );
};
